module.exports = __webpack_public_path__ + "img/bz.cbbe4ee8.svg";